'use strict';

const restConfig = require('../../../../config/api/rest.js');

const actions = {
	initial: {
		routes: {},
		collections: {}
	}
};

let unhook = () => {};

const hook = ({state$, actions}) => {
	actions.set('rest', restConfig);
};

module.exports = {
	actions,
	config: restConfig,
	hook,
	unhook
};
